<script setup lang="ts">
/**
 * Údržba strip (useMaintenance). Clients: what is going on and until when;
 * admins: a small reminder that clients are locked out right now.
 * Mounted by SidebarLayout (every app screen) and layouts/empty.vue (/auth/*).
 */
import { useMaintenance } from '~/composables/useMaintenance'

const { state, isAdmin, untilLabel } = useMaintenance()
</script>

<template>
  <div v-if="state.enabled && isAdmin" class="mnt mnt--admin" role="status">
    <span class="mnt__pill">🔧 Údržba zapnutá</span>
    <span class="mnt__text">Klienti teď nemohou upravovat weby.</span>
    <NuxtLink to="/admin/maintenance/" class="mnt__link">Nastavení údržby</NuxtLink>
  </div>
  <div v-else-if="state.enabled" class="mnt" role="alert">
    <span class="mnt__icon" aria-hidden="true">🔧</span>
    <span class="mnt__text">
      <strong>Údržba:</strong> {{ state.message }}
      <template v-if="untilLabel"> (předpokládaný konec {{ untilLabel }})</template>
    </span>
  </div>
</template>

<style scoped>
.mnt {
  position: sticky;
  top: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 16px;
  background: #fff4dc;
  border-bottom: 1px solid #ecd39a;
  color: #6b4a07;
  font-size: 13.5px;
  line-height: 1.4;
}
.mnt__icon {
  flex: none;
}
.mnt__text {
  flex: 1;
  min-width: 0;
}
.mnt--admin {
  background: #eef0fa;
  border-bottom-color: #d5dbf2;
  color: #243179;
  font-size: 12.5px;
  padding: 6px 16px;
}
.mnt__pill {
  flex: none;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 999px;
  background: #fff4dc;
  color: #6b4a07;
  border: 1px solid #ecd39a;
}
.mnt__link {
  flex: none;
  color: #2b3a8f;
  font-weight: 600;
  text-decoration: underline;
}
</style>
